import React from 'react';
import immutableTransform from 'redux-persist-transform-immutable';
import localForage from 'localforage';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import createStore from './common/createStore';
import App from './App.react';
import { InitialState } from './common/healthCheck/reducer';

const store = createStore(window.REDUX_STATE || {}, { middlewares: [] });

export const persistor = persistStore(store, {
  storage: localForage,
  blacklist: ['onionForm'],
  transforms: [immutableTransform({ records: [InitialState] })],
});

export default () => (
  <Provider store={store}>
    <App />
  </Provider>
);
